import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckboxSetting from '../settings/CheckboxSetting';
import { Form, Row } from 'react-bootstrap';
import { HtmlFieldModel } from '../../../../../../models/form/fields/html';
import ColorSetting from '../settings/ColorSetting';
import { updateSelectedField, selectedFieldSelector } from '../../../../../../slices/formadmin';
import { RootState } from '../../../../../../store';
import CultureTextSetting from '../settings/CultureTextSetting';

const HtmlProperties: FC = () => {
  const field = useSelector(selectedFieldSelector) as HtmlFieldModel;
  const selectedLanguage = useSelector((state: RootState) => state.formAdmin.selectedLanguage) as string;
  const dispatch = useDispatch();

  return (
    <Form>
      <Row className="align-items-center">
        <CultureTextSetting
          id={`field.${field.id}.text`}
          culture={selectedLanguage}
          value={field.text}
          label="adminProperties.fields.common.text"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                text: val,
              }),
            )
          }
        />
        <ColorSetting
          value={field.textColor}
          label="adminProperties.fields.common.textColor"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                textColor: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'hiddenText'}
          checked={field.hiddenText}
          label="adminProperties.fields.common.hiddenText"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                hiddenText: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'visible'}
          checked={field.visible}
          label="adminProperties.fields.common.visible"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                visible: val,
              }),
            )
          }
        />
      </Row>
    </Form>
  );
};

export default HtmlProperties;
